import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-espresso py-16 text-cream sm:py-20" aria-labelledby="problem-heading" data-id="element-201" data-mp="2ltmglpx0jlk0">
      <div className="mx-auto max-w-5xl px-5" data-id="element-202" data-mp="30jal100hr0by">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-goldlight" data-id="element-203" data-mp="2vq7p4l88resl">
          The reality of doing hair
        </p>
        <h2 id="problem-heading" className="mt-4 max-w-2xl font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl" data-id="element-204" data-mp="39g2t14s8bazg">
          Doing hair at home? These problems sound familiar?
        </h2>
        <p className="mt-4 font-display text-xl text-cream/70" data-id="element-205" data-mp="3eh8o399d3ac5">
          How much longer are you willing to improvise?
        </p>

        <ul className="mt-10 grid gap-x-10 gap-y-5 md:grid-cols-2" data-id="element-206" data-mp="1p2u1auhwlxja">
          {problems.map(problem => <li key={problem} className="flex items-start gap-3" data-id="element-207" data-mp="1k4irukvitp1l">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-alert" aria-hidden="true" data-id="element-208" data-mp="jdn3jz60wq2t">
                <XIcon className="h-3 w-3 text-cream" strokeWidth={3} data-id="element-209" data-mp="sdtd59ylp5wp" />
              </span>
              <p className="font-sans text-base leading-relaxed text-cream/85" data-id="element-210" data-mp="x4i5ssm0o8xf">
                {problem}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}